import { useMutation } from '@tanstack/react-query';
import { authService } from 'shared/src/api';

export const usePostTermsAgreementVerify = () => {
  return useMutation({
    mutationFn: authService.postTermsAgreementVerify,
    throwOnError: false,
  });
};
